import toast from 'react-hot-toast';

export default function useToast() {
  return toast;
}
